// constants
import { ResultSetActionTypes } from './constants';
import { ResultSet as ResultSetData } from 'src/types/resultSet';

export type ResultSetActionType = {
    type:
        | ResultSetActionTypes.API_RESPONSE_SUCCESS
        | ResultSetActionTypes.API_RESPONSE_ERROR
        | ResultSetActionTypes.ADD_RESULT_SET
        | ResultSetActionTypes.EDIT_RESULT_SET
        | ResultSetActionTypes.GET_RESULT_SET
        | ResultSetActionTypes.GET_RESULT_SETS
        | ResultSetActionTypes.RESET
        | ResultSetActionTypes.RESET_SUCCESS
        | ResultSetActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const resultSetApiResponseSuccess = (
    actionType: string,
    data: ResultSetData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ResultSetActionType => ({
    type: ResultSetActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const resultSetApiResponseError = (
    actionType: string,
    data: ResultSetData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ResultSetActionType => ({
    type: ResultSetActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addResultSet = (params: any): ResultSetActionType => ({
    type: ResultSetActionTypes.ADD_RESULT_SET,
    payload: params,
});

export const editResultSet = (params: any): ResultSetActionType => ({
    type: ResultSetActionTypes.EDIT_RESULT_SET,
    payload: params,
});

export const GetResultSets = (params: any): ResultSetActionType => ({
    type: ResultSetActionTypes.GET_RESULT_SETS,
    payload: params,
});

export const GetResultSet = (params: any): ResultSetActionType => ({
    type: ResultSetActionTypes.GET_RESULT_SET,
    payload: params,
});

export const resetResultSet = (): ResultSetActionType => ({
    type: ResultSetActionTypes.RESET,
    payload: {},
});

export const resetResultSetSuccess = (): ResultSetActionType => ({
    type: ResultSetActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetResultSetError = (): ResultSetActionType => ({
    type: ResultSetActionTypes.RESET_ERROR,
    payload: {},
});
